import uniqueId from '@form-create/utils/lib/unique';
import { makeOptionsRule, makeRequiredRule } from '../../utils';
var label = '内容说明';
var name = 'infoForm';
export default {
  icon: 'iconfont iconxuanzeqi',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      effect: {
        fetch: ''
      },
      props: {
        value: '',
        title: ''
      },
      checkType: 0
    };
  },
  props: function props() {
    return [makeOptionsRule('props'), makeRequiredRule()];
  },
  basic: function basic() {}
};